import { Controller } from 'stimulus'

// Removing the logo only takes effect when the form is saved.
export default class extends Controller {
  static targets = ['input', 'preview', 'image', 'empty', 'name', 'remove', 'removeButton', 'pickLabel']

  pick(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  change() {
    const file = this.inputTarget.files[0]
    if (file) this._show(file)
  }

  dragover(event) {
    event.preventDefault()
    this.previewTarget.classList.add('logo-field__frame--over')
  }

  dragleave() {
    this.previewTarget.classList.remove('logo-field__frame--over')
  }

  drop(event) {
    event.preventDefault()
    this.dragleave()
    const file = event.dataTransfer.files[0]
    if (!file || !file.type.startsWith('image/')) return

    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.inputTarget.files = transfer.files
    this._show(file)
  }

  remove(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.removeTarget.value = '1'
    this.imageTarget.removeAttribute('src')
    this._toggle(false)
    this.nameTarget.textContent = this.data.get('emptyLabel')
  }

  _show(file) {
    this.removeTarget.value = '0'
    this.imageTarget.src = URL.createObjectURL(file)
    this.nameTarget.textContent = `${file.name} · ${Math.max(1, Math.round(file.size / 1024))} ${this.data.get('sizeUnit')}`
    this._toggle(true)
  }

  _toggle(present) {
    this.imageTarget.classList.toggle('d-none', !present)
    this.emptyTarget.classList.toggle('d-none', present)
    this.removeButtonTarget.classList.toggle('d-none', !present)
    this.pickLabelTarget.textContent = present ? this.data.get('replaceLabel') : this.data.get('pickLabel')
  }
}
